'use strict';

/**
 * List of all objects
 *
 * @category   View
 * @module     collection
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ListLayout = require('modules/collection/views/layout/list');
var EmptyShopView = require('../partials/list-shop-empty');
var ShopHeaderView = require('./shop-header');

var ShopObjectListLayout = ListLayout.extend({
    showListActions: false,

    getHeaderViewClass: function () {
        App.CollectionModule.ShopModule.shops.setActiveShop(this.model.catalog.id);

        return ShopHeaderView;
    },

    getEmptyViewClass: function() {
        return EmptyShopView;
    },
});

module.exports = ShopObjectListLayout;